import { ArrowLeft } from "lucide-react";
import { ButtonLink } from "../components/ui";

export function NotFoundPage() {
  return (
    <main className="not-found">
      <span><img src="/brand/mira-symbol-white.svg" alt="" /></span>
      <p>404</p>
      <h1>Esta página saiu da rota.</h1>
      <small>O endereço informado não existe ou foi movido.</small>
      <ButtonLink to="/"><ArrowLeft /> Voltar para a central</ButtonLink>
    </main>
  );
}
